import { render } from "./Cleanup.vue?vue&type=template&id=bfd1c1f0"
import script from "./Cleanup.vue?vue&type=script&lang=js"
export * from "./Cleanup.vue?vue&type=script&lang=js"
script.render = render

export default script